import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import VideoHeader from "../components/accueil/videoHeader";
import AnnonceSection from "../components/accueil/annonceSection";
import Carrousel from "../components/accueil/carrousel";
import DataSection from "../components/accueil/dataSection";
import Partners from "../components/accueil/partrner";
import { API } from "../api";
import PageLoader from "../components/PageLoader";

export default function Accueil() {
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const result = await API.get("dataSet?p:dataSet=home");
        if (!cancelled) setData(result);
      } catch (err) {
        console.error(err);
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <PageLoader label="Chargement de l'accueil" />;
  if (error) return <div>Erreur : {error}</div>;
  console.log("Accueil Data:", data);

  return (
    <div>
      <VideoHeader data={data.extras}/>
      {data.current_events && ( <AnnonceSection dataEvents={data.current_events} /> )}
      {data.configuration.is_home_restricted === false && (
      <>
        <Carrousel data={data.carrousel} />
        <DataSection data={data} />
        <Partners data={data.partners} />
      </>
      )}
    </div>
  );
}